import R from "../../../R";

export function CircleQuestionMark({
  height,
  width,
  color,
}: {
  readonly height?: number;
  readonly width?: number;
  readonly color?: string;
}) {
  return (
    <svg
      data-testid="circle-question-mark"
      width={height || 20}
      height={width || 20}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0003 13.0001V11.0001H11.667C12.7716 11.0001 13.667 10.1047 13.667 9.00008V8.86675C13.667 7.83582 12.8313 7.00008 11.8003 7.00008H11.0003C9.89576 7.00008 9.00033 7.89551 9.00033 9.00008M10.3337 15.0001H11.667M11.0003 20.3334C5.84567 20.3334 1.66699 16.1547 1.66699 11.0001C1.66699 5.84542 5.84567 1.66675 11.0003 1.66675C16.155 1.66675 20.3337 5.84542 20.3337 11.0001C20.3337 16.1547 16.155 20.3334 11.0003 20.3334Z"
        stroke={color || R.colors.vividBlue}
        strokeWidth="1.5"
      />
    </svg>
  );
}
